import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { useDeliveryService } from "../../../services/deliveryService"
import { DeliveryMethod, DeliveryOrder } from "../../../state/types"
import { DeliveryItemRow } from "../../types"

export const useActions = () => {
    const { createDelivery: createDeliveryService } = useDeliveryService()

    const { closeModal } = useUIActions()

    const createDelivery = async (
        deliveryOrder: DeliveryOrder,
        deliveryDate: Date,
        itemsData: DeliveryItemRow[],
        deliveryNoteFile?: File,
        supplierDeliveryNoteNumber?: string
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const isPickupOrReception = deliveryOrder.method === DeliveryMethod.PICKUP || deliveryOrder.method === DeliveryMethod.RECEPTION
        const deliveryItemsData = itemsData
            .filter(item => item.quantity > 0)
            .map(item => ({
                itemId: item.itemId,
                quantity: item.quantity,
                deliveredQuantity: isPickupOrReception ? item.quantity : 0,
                notDeliveredQuantity: 0,
                lotData: item.lotData
            }))

        try {
            await createDeliveryService(deliveryOrder.id, deliveryDate, deliveryItemsData, deliveryNoteFile, supplierDeliveryNoteNumber)

            Emitter.emit(Event.DB_SUBMIT_DONE, true)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo generar el remito.')
        }
    }

    return {
        createDelivery
    }
}
